import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UpdateIntegrationConfirmComponent } from "./update-integration-confirm.component";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { InfoBannerComponentModule } from "../../components/info-banner/info-banner.module";
import { FormFieldWrapperComponentModule } from "../../components/form-field-wrapper/form-field-wrapper.module";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    InfoBannerComponentModule,
    FormFieldWrapperComponentModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
  ],
  declarations: [UpdateIntegrationConfirmComponent],
  exports: [UpdateIntegrationConfirmComponent],
})
export class UpdateIntegrationConfirmComponentModule {}
